var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "formValidation",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ pristine, handleSubmit, invalid }) {
          return [
            _c(
              "form",
              {
                staticClass: "user-group form-horizontal",
                attrs: { role: "form" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.onSaveAll)
                  }
                }
              },
              [
                _c(
                  "fieldset",
                  [
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("LABEL_NAME"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("TOOLTIP_NAME")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "ValidationProvider",
                                  { attrs: { rules: "required", slim: "" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-5 col-md-3" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.groupName,
                                              expression: "groupName"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            type: "text",
                                            required: "true"
                                          },
                                          domProps: { value: _vm.groupName },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.groupName =
                                                $event.target.value
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("LABEL_TYPE"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("TOOLTIP_TYPE")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "ValidationProvider",
                                  { attrs: { rules: "required", slim: "" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-5 col-md-3" },
                                      [
                                        _vm.newGroup
                                          ? _c("v-select", {
                                              staticClass: "form-input",
                                              attrs: {
                                                options: [
                                                  {
                                                    label: "Publisher",
                                                    id: "Affiliate"
                                                  },
                                                  {
                                                    label: "Buyer",
                                                    id: "Buyer"
                                                  }
                                                ],
                                                searchable: false,
                                                clearable: false,
                                                reduce: option => option.id
                                              },
                                              on: {
                                                "option:selecting":
                                                  _vm.onTypeChange
                                              },
                                              model: {
                                                value: _vm.type,
                                                callback: function($$v) {
                                                  _vm.type = $$v
                                                },
                                                expression: "type"
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !_vm.newGroup
                                          ? _c("input", {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip.right",
                                                  value: _vm.$t(
                                                    "TOOLTIP_NEW_TYPE"
                                                  ),
                                                  expression:
                                                    "$t('TOOLTIP_NEW_TYPE')",
                                                  modifiers: { right: true }
                                                }
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                disabled: "true"
                                              },
                                              domProps: {
                                                value: _vm.typeReadOnly
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("LABEL_ADMIN_REPORT"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("TOOLTIP_ADMIN_REPORT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "ValidationProvider",
                                  { attrs: { rules: "required", slim: "" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-5 col-md-3" },
                                      [
                                        _c("nzToggle", {
                                          model: {
                                            value: _vm.adminReportView,
                                            callback: function($$v) {
                                              _vm.adminReportView = $$v
                                            },
                                            expression: "adminReportView"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("LABEL_READ_ONLY"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("TOOLTIP_READ_ONLY")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "ValidationProvider",
                                  { attrs: { rules: "required", slim: "" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "col-sm-5 col-md-3" },
                                      [
                                        _c("nzToggle", {
                                          model: {
                                            value: _vm.readOnly,
                                            callback: function($$v) {
                                              _vm.readOnly = $$v
                                            },
                                            expression: "readOnly"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("LABEL_LINKED_ITEMS"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("TOOLTIP_LINKED_ITEMS")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "col-sm-9 col-md-6" },
                                  [
                                    _c(
                                      "ValidationProvider",
                                      {
                                        ref: "itemIdsValidation",
                                        attrs: { slim: "" }
                                      },
                                      [
                                        _c("MultiSelect", {
                                          staticClass: "multi-select-lg",
                                          attrs: {
                                            "list-items": _vm.items,
                                            "display-property": "name",
                                            "value-property": "id",
                                            "no-options-text": _vm.$t(
                                              "EMPTY_LINKED_ITEMS"
                                            )
                                          },
                                          on: { input: _vm.onItemIdsChange },
                                          model: {
                                            value: _vm.selectedItemIds,
                                            callback: function($$v) {
                                              _vm.selectedItemIds = $$v
                                            },
                                            expression: "selectedItemIds"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3"
                        },
                        [
                          _c(
                            "PrimaryButton",
                            {
                              attrs: {
                                size: "sm",
                                disabled: pristine || invalid,
                                "show-loader-on-form": _vm.showLoader
                              },
                              on: { click: _vm.submit }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("SAVE")) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("button", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "CANCEL",
                                expression: "'CANCEL'"
                              }
                            ],
                            staticClass: "btn btn-sm btn-danger m-l-15",
                            on: { click: _vm.cancel }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }